<template>
    <div class="animated fadeIn">

        <b-card>
            <div class="btn-group pull-right mb-2">
                <button class="btn btn-success btn-sm" @click="onCreate()">Добавить заболевание</button>
            </div>
            <v-server-table :url="apiurl('disease/table')"  :columns="columns" :options="options" :theme="theme" id="commonTable" ref="commonTable" name="commonTable28" class="table-sm">
                <a slot="edit" slot-scope="props" href="#" @click.prevent="onEdit(props.row)"><i class="fa fa-edit fa-lg text-primary"></i></a>
                <a slot="delete" slot-scope="props" href="#" @click.prevent="onDelete(props.row)"><i class="fa fa-trash fa-lg text-danger"></i></a>
            </v-server-table>
        </b-card>

        <b-modal title="Подтвердите удаление" class="modal-danger" centered  v-model="deleteConfirmModal" ok-variant="danger" @ok="handleDelete()">
            Вы собираетесь безвозвратно удалить заболевание <strong>"{{deleteConfirmTitle}}"</strong>. Заболевание будет удалено безвозвратно.
            Все связи заболевания <strong>"{{deleteConfirmTitle}}"</strong> с объектами будут также удалены.
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">нет, передумал</b-button>
                <b-button size="sm" variant="outline-danger" @click="ok()">да, удалить</b-button>
            </template>
        </b-modal>

        <disease-edit-dialog v-model="editDisease" v-if="editDisease" @changed="onDiseaseChanged"></disease-edit-dialog>

    </div>
</template>

<script>

    import {CONSTANTS} from '@/constants';
    import { functions } from '@/functions.js';
    import { functions_hotel_data } from '@/functions_hotel_data.js';
    import DiseaseEditDialog from '@/dialogs/DiseaseEditDialog';

    export default {
        name: 'NsbTechDiseases',
        components: {
            DiseaseEditDialog
        },
        mixins: [functions, functions_hotel_data],
        data: function () {
            return {
                data:[],
                columns: ['id', 'title', 'category.title', 'edit', 'delete' ],
                options: {
                    saveState: true,
                    headings: {
                        id: '#',
                        title: 'заболевание',
                        'category.title': 'группа заболеваний',
                        edit: function(h) { return (
                            <i class="fa fa-edit fa-lg" title="редактирование"></i>
                        ) },
                        delete: function(h) { return (
                            <i class="fa fa-trash fa-lg" title="удаление"></i>
                        ) },
                    },
                    sortable: ['id', 'title' ],
                    filterable: ['id', 'title', 'category.title' ],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    perPage:25,
                    perPageValues:[25,50,100],
                    pagination: {
                        chunk: 20,
                        edge: false,
                        nav: 'scroll'
                    },
                    filterByColumn: true,
                    debounce:1000,
                    columnsClasses: { edit: "text-center", delete: "text-center", },
                },
                theme: 'bootstrap4',
                template: 'default',

                deleteConfirmModal: false,
                deleteConfirmTitle: '',
                deleteConfirmDisease: null,
                editDisease: null,
            }
        },
        methods: {
            onDelete: function(disease) {
                this.deleteConfirmModal=true;
                this.deleteConfirmTitle = disease.title;
                this.deleteConfirmDisease = disease;
            },
            handleDelete: function() {
                this.deleteDisease(this.deleteConfirmDisease.id, function(self, response){
                    self.$refs.commonTable.refresh();
                }, this);
            },
            onEdit: function(disease) {
                this.editDisease = disease.id;
            },
            onCreate: function() {
                this.createDisease(function(self, disease){
                    self.$refs.commonTable.refresh();
                    self.editDisease = disease.id;
                }, this);
            },
            onDiseaseChanged: function ($param) {
                this.$refs.commonTable.refresh();
            }
        },
        created: function() {
        }
    };
</script>

<style lang="scss">

</style>
